"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackFlowStarted = trackFlowStarted;
exports.trackFlowCompleted = trackFlowCompleted;
exports.trackFlowStepCompleted = trackFlowStepCompleted;
exports.trackFlowStepViewed = trackFlowStepViewed;
exports.trackFlowStepSkipped = trackFlowStepSkipped;
exports.default = void 0;

var _trackingHelper = require("../trackingHelper");

var _flowTags = require("./flowTags");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Helper to make sure the flog tags we are passing into the tracking db are
 * in the allowed list of tags.  If our apps were all 100% typescript, we wouldn't
 * need this, but as soon as one place calls trackFlowStarted or trackFlowCompleted
 * in JavaScript with a tag that isn't allow, then we've polluted our tracking
 * database forever.
 */
var filterFlowPayload = function filterFlowPayload(payload) {
  return 'tags' in payload ? _objectSpread(_objectSpread({}, payload), {}, {
    tags: (0, _flowTags.filterFlowTags)(payload.tags)
  }) : payload;
};
/**
 * Fire when a multi-step action is started.  This
 *
 */


function trackFlowStarted(payload) {
  (0, _trackingHelper.trackEvent)('Flow Started', filterFlowPayload(payload));
}

function trackFlowCompleted(payload) {
  (0, _trackingHelper.trackEvent)('Flow Completed', filterFlowPayload(payload));
}
/**
 * The set of all properties sent to Segment
 */


/**
 * Indicates that the step in the flow has been completed.  The flow step completed
 * events let us know where in a multi-step flow the user drops off.
 *
 * Note: this method must be sent to ensure correct funnel analysis of user behavior
 */
function trackFlowStepCompleted(payload) {
  (0, _trackingHelper.trackEvent)('Flow Step Completed', payload);
}
/**
 * Note: this method is not used to analyze user drop-off. Be sure to send trackFlowStepCompleted
 *
 * @deprecated We are no longer using flow step viewed for analysis.
 */


function trackFlowStepViewed(payload) {
  (0, _trackingHelper.trackEvent)('Flow Step Viewed', payload);
}
/**
 * When an optional step in the flow is skipped instead of completed, fire this.
 */


function trackFlowStepSkipped(payload) {
  (0, _trackingHelper.trackEvent)('Flow Step Skipped', payload);
}

var _default = {
  trackFlowCompleted: trackFlowCompleted,
  trackFlowStarted: trackFlowStarted,
  trackFlowStepCompleted: trackFlowStepCompleted,
  trackFlowStepSkipped: trackFlowStepSkipped,
  trackFlowStepViewed: trackFlowStepViewed
};
exports.default = _default;